export const BASE_DASHBOARD_PATH = '/dashboard'
